import { IconName } from '@ailibs/feather-react-ts';
import { isValidElement } from 'react';

export const isFeatherIcon = (icon: IconName | JSX.Element): icon is IconName => {
  return !isValidElement(icon);
};
